import React, { useEffect, useRef, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight, FaRegPlayCircle } from 'react-icons/fa';
import VideoPopUp from '../common/videoPopUp';
import Cookies from 'js-cookie';

import { useTranslation } from "react-i18next";

function FormationVideos({ data }) {

    const [t] = useTranslation("formation")
    const [loading, setLoading] = useState(false);

    const [showPopup, setShowPopup] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);

    const [videos, setVideos] = useState([]);

    const [welcomeVid, setWelcomeVid] = useState({});
    const [displayLeftChevon, setDisplayLeftChevon] = useState(false);
    const [displayRightChevon, setDisplayRightChevon] = useState(true);

    const [displayWelcomeVideo, setDisplayWelcomeVideo] = useState(Cookies.get('myreportin_welcome_video'));


    const scrollContainerRef = useRef(null);

    const handleScroll = () => {
        const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;

        if (scrollLeft === 0) {
            setDisplayRightChevon(true)
            setDisplayLeftChevon(false)
        } else if (scrollLeft + clientWidth === scrollWidth) {
            setDisplayLeftChevon(true)
            setDisplayRightChevon(false)
        } else {
            setDisplayLeftChevon(true)
            setDisplayRightChevon(true)
        }
    };


    const handleScrollRightClick = () => {
        if (scrollContainerRef.current) {
            const scrollAmount = 10000;
            scrollContainerRef.current.scrollLeft += scrollAmount;
        }
    };

    const handleScrollLeftClick = () => {
        if (scrollContainerRef.current) {
            const scrollAmount = 10000;
            scrollContainerRef.current.scrollLeft -= scrollAmount;
        }
    };

    const handleVideoPopUpClose = () => {
        setShowPopup(false);
    };

    const handleOpenVideo = (iframe) => {
        setSelectedVideo(iframe);
        setShowPopup(true);

    };


    useEffect(() => {

        const welcomeVideoIndex = data.findIndex(item => item.firstVideo === true);

        if (welcomeVideoIndex !== -1) {

            setWelcomeVid(data[welcomeVideoIndex]);

            if (!displayWelcomeVideo) {

                handleOpenVideo(data[welcomeVideoIndex].video)

                if (Cookies.get('myreportin_cookies_enabled')) {
                    Cookies.set('myreportin_welcome_video', true, { expires: 730, secure: true, sameSite: 'none' });
                }
            }

            // Crea una copia del array original sin el video de bienvenida
            const newData = [...data];
            newData.splice(welcomeVideoIndex, 1);
            newData.sort((a, b) => a.title.localeCompare(b.title)); // Ordena por la propiedad 'title'


            // Actualiza el estado de data
            setVideos(newData)
        }

    }, [data]);


    useEffect(() => {

    }, []);

    return (
        <>
            {videos.length > 0 ? (
                <>
                    <VideoPopUp
                        show={showPopup}
                        title={""}
                        iframe={selectedVideo}
                        handleClose={handleVideoPopUpClose}
                    />

                    <div className='mt-4'>
                        <Row >
                            <span className='formation-title-big'>{t("formation.firstSteps")}</span>
                            <Col md={6} className='d-flex justify-content-start'>
                                <Row >
                                    {/* Renderizar el video  */}
                                    <div className='col-md-6'>
                                        <div
                                            className='formation-video'
                                            onClick={() => handleOpenVideo(welcomeVid.video)}
                                        >
                                            <img className='w-100 custom-shadow-bold mt-2' src={welcomeVid.thumbnail} />
                                            <FaRegPlayCircle className='formation-play-icon' size={70} />
                                        </div>

                                    </div>
                                </Row>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <span className='formation-title-big'>{t("formation.startFormation")}</span>
                            <Col md={12} className='d-flex justify-content-start'>

                                <div
                                    className='formation-lessons-container'
                                    ref={scrollContainerRef}
                                    onScroll={handleScroll}
                                >

                                    <FaChevronLeft
                                        className='formation-scroll-left-icon'
                                        style={{
                                            opacity: displayLeftChevon ? 1 : 0,
                                            transition: 'opacity 0.2s ease-in-out'
                                        }}
                                        onClick={handleScrollLeftClick}
                                    />

                                    <FaChevronRight
                                        className='formation-scroll-right-icon'
                                        style={{
                                            opacity: displayRightChevon ? 1 : 0,
                                            transition: 'opacity 0.2s ease-in-out'
                                        }}
                                        onClick={handleScrollRightClick}
                                    />

                                    {videos.map((lesson, index) => (
                                        <div className='formation-lesson' key={index}>
                                            <span className='formation-title'>{lesson.title}</span>
                                            <div className='formation-video' onClick={() => handleOpenVideo(lesson.video)}>
                                                <img className='w-100 custom-shadow-bold mt-2' src={lesson.thumbnail} />
                                                <FaRegPlayCircle className='formation-play-icon' size={70} />
                                            </div>
                                        </div>
                                    ))}

                                </div>

                            </Col>
                        </Row>
                    </div>
                </>
            ) : (
                <div className="formation-card-loading-container">
                    <div className="formation-card-loading-row ">
                        <div className="formation-card-loading-popup custom-shadow-bold rounded-border-px">
                            <Spinner animation="border" className="spinner-bigger" />
                        </div>
                    </div>
                </div>

            )
            }

        </>
    );

}

export default FormationVideos;